export const validateOrderForm = (formData) => {
    const errors = {};

    if (!formData.fName.trim()) {
        errors.fName = "First name is required";
    }

    if (!formData.address.trim()) {
        errors.address = "Address is required";
    }
    // if (
    //     !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formData.email)
    // ) {
    //     errors.email = "Invalid email address";
    // }

    if (!formData.mobileNo.trim()) {
        errors.mobileNo = "Mobile number is required";
    } else if (!/^[0-9]{10}$/.test(formData.mobileNo)) {
        errors.mobileNo = "Mobile number must be 10 digits";
    }

    if (!formData.state) {
        errors.state = "Please select state";
    }

    if (!formData.city.trim()) {
        errors.city = "City is required";
    }

    if (!formData.pincode.trim()) {
        errors.pincode = "Pincode is required";
    } else if (!/^[0-9]{6}$/.test(formData.pincode)) {
        errors.pincode = "Pincode must be 6 digits";
    }

    if (!formData.payment) {
        errors.payment = "Select payment type";
    }

    if (!formData.issueDisease) {
        errors.issueDisease = "Select issue/disease";
    }
    if (!formData.teleCallName) {
        errors.teleCallName = "Select Name";
    }

    formData.orderItems.forEach((item, index) => {
        if (!item.productName) {
            errors[`productName_${index}`] = "Select product";
        }

        if (Number(item.price) <= 0) {
            errors[`price_${index}`] = "Invalid price";
        }

        if (Number(item.quantity) <= 0) {
            errors[`quantity_${index}`] = "Invalid quantity";
        }
    });

    return errors;
};